import { stateSwitch } from '../stateSwitch';
import { spenttimeDebug as debug } from '../debug';
import { restartTimers } from './userActivityEvents';
var containerIntersectionObserver = null;
/**
 * The handler that is executed when the visibility of the container changes
 * Can set the state 'containerIsVisible'
 * @param entries Interface of the Intersection Observer
 */
var containerVisibilityHandler = function (entries) {
    if (!Array.isArray(entries) || entries.length === 0) {
        return;
    }
    var isIntersecting = entries[0].isIntersecting; // only container element
    debug("Element is ".concat(isIntersecting ? '' : 'not ', "visible \"container\""));
    stateSwitch.setState({
        containerIsVisible: isIntersecting,
        userIsSleeping: false,
        pageIsVisible: true,
    });
    if (isIntersecting) {
        restartTimers();
    }
};
/**
 * Adds container visibilitychange event handler
 */
export var addContainerVisibilityEventListener = function () {
    containerIntersectionObserver = new IntersectionObserver(containerVisibilityHandler, {
        threshold: [stateSwitch.config.container.intersectionThreshold],
    });
    debug({
        message: "[conta]: threshold = [".concat(stateSwitch.config.container.intersectionThreshold, "]"),
    });
    containerIntersectionObserver.observe(stateSwitch.config.container.element);
    debug('[event] Container visibility event listener have been added');
};
/**
 * Removes container visibilitychange event listener
 */
export var removeContainerVisibilityEventListener = function () {
    containerIntersectionObserver.unobserve(stateSwitch.config.container.element);
    containerIntersectionObserver = null;
    debug('[event] Container visibility event listener have been disabled');
};
